import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { installAuthAxiosGuard } from './services/authAxiosGuard';
installAuthAxiosGuard();

// 2026-05-20: Global error filter - mute noise from browser extensions (AdBlock, Grammarly, password managers, etc.)
// These errors are NOT from our app, they pollute the console and make real bugs harder to spot.
const EXTENSION_NOISE_PATTERNS = [
  /message channel closed before a response was received/i,
  /A listener indicated an asynchronous response by returning true/i,
  /Extension context invalidated/i,
  /Could not establish connection\. Receiving end does not exist/i,
  /chrome-extension:\/\//i,
  /moz-extension:\/\//i,
];

const isExtensionNoise = (msg) => {
  if (!msg) return false;
  const text = typeof msg === 'string' ? msg : (msg.message || msg.toString());
  return EXTENSION_NOISE_PATTERNS.some((re) => re.test(text));
};

window.addEventListener('unhandledrejection', (event) => {
  const reason = event.reason;
  const msg = reason && (reason.message || reason.toString && reason.toString());
  if (isExtensionNoise(msg)) {
    event.preventDefault();
    event.stopImmediatePropagation();
  }
});

window.addEventListener('error', (event) => {
  if (isExtensionNoise(event.message) || (event.filename && /chrome-extension:|moz-extension:/.test(event.filename))) {
    event.preventDefault();
    event.stopImmediatePropagation();
    return true;
  }
}, true);

// Also patch console.error to filter the same patterns (some libs log via console.error without throwing)
const originalConsoleError = console.error;
console.error = function (...args) {
  try {
    const first = args[0];
    if (isExtensionNoise(first)) return;
  } catch (e) {}
  return originalConsoleError.apply(console, args);
};

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);
